import { _ } from "../../../core/polyglot/polyglot.js";
import { Dropdown, MenuItem } from "prosemirror-menu";
import { timesSolidIcon } from "../../../core/elements/icons/index.js";

export const defaultDropdownMenuItemBuilder = ({
	items,
	...dropdownOptions
}) => ({
	render: (view) => {
		let updateFn = (..._args) => true;
		const loader = document.createElement("div");
		loader.setAttribute("data-test", "prosemirror-menu-item-loader");
		loader.classList.add("css-loader");

		const dom = document.createElement("div");
		dom.setAttribute("data-test", "prosemirror-menu-item");
		dom.appendChild(loader);

		fetchItems({
			dom,
			items,
			dropdownOptions,
			view,
			setUpdateFn: (fn) => (updateFn = fn),
		});

		return {
			dom,
			update: (...args) => updateFn(...args),
		};
	},
});

async function fetchItems({ items, dom, view, dropdownOptions, setUpdateFn }) {
	let resolvedItems;
	try {
		resolvedItems = await Promise.resolve(items);
	} catch (error) {
		// eslint-disable-next-line no-console -- this is for dev purposes
		console.error(error);
		renderError({ dom, error });
		return;
	}

	const dropdown = new Dropdown(
		resolvedItems.map((item) => {
			if (!item.label && !item.icon) {
				item.icon = makeIcon(item.iconSpecs);
			}

			return new MenuItem(item);
		}),
		dropdownOptions,
	);
	const { dom: dropdownDom, update: dropdownUpdate } = dropdown.render(view);
	renderItems({ dom, dropdownDom });
	setUpdateFn(dropdownUpdate);
}

function renderItems({ dom, dropdownDom }) {
	dom.innerHTML = "";
	dom.classList.add("ProseMirror-menu-dropdown-wrap-async");
	dom.appendChild(dropdownDom);
}

function renderError({ dom, error }) {
	dom.innerHTML = `<div data-test="prosemirror-menu-item-error" data-error="${encodeURI(
		error.message,
	)}" class='${timesSolidIcon.getCssClass()} async-error'></div>`;

	dom.parentNode.classList.add("disabled");

	dom.parentNode.title = _("Error while loading the menu items").toString();
}

function makeIcon({ klass, text = "" }) {
	const sup = document.createElement("sup");
	sup.innerText = text;
	const icon = document.createElement("icon");
	icon.className = klass;
	icon.appendChild(sup);
	return { dom: icon };
}
